var React = require('react');

function ReviewStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5 2L13.7451 8.90983H21.0106L15.1327 13.1803L17.3779 20.0902L11.5 15.8197L5.62215 20.0902L7.86729 13.1803L1.98944 8.90983H9.25486L11.5 2Z","stroke":"#FABC3F"}));
}

ReviewStar.defaultProps = {"width":"23","height":"24","viewBox":"0 0 23 24","fill":"none"};

module.exports = ReviewStar;

ReviewStar.default = ReviewStar;
